import { showChatMaintenanceIcon } from './client/common/components/ChatMaintenanceIcon'

const pearDeckSLD = 'peardeck' // Peardeck Second-level Domain
// Don't put any sensitive information
// https://edupoc.s3.amazonaws.com/edulasticv2-development/JS/thirdpartylib/ev2-scientificcalc/CalcSS3.js
let cdnURI =
  process.env.REACT_APP_CDN_URI ||
  'https://cdnedupoc.snapwiz.net/edulasticv2-development'
if (window.origin.indexOf(pearDeckSLD) > -1) {
  cdnURI = process.env.REACT_APP_PEAR_CDN_URI || cdnURI
}
const appEnv = process.env.REACT_APP_ENV
const appStage = process.env.REACT_APP_STAGE || 'development'
// __CLIENT_VERSION__ is injected to envs in poi.config.js
// using it to avoid importing json for just version
const appVersion = process.env.__CLIENT_VERSION__ || 'NA'
const pearScriptPath = `${
  process.env.REACT_APP_PEAR_SCRIPT_PATH ||
  'https://stg-account.peardeck.com/psi/index.js'
}?paAppVersion=${appVersion}`
const pearScriptDomainIdentifier =
  process.env.REACT_APP_PEAR_SCRIPT_DOMAIN_IDENTIFIER || 'peardeck.com'
const thirdPartyLibPath = `${cdnURI}/JS/thirdpartylib`
const jqueryPath = `${thirdPartyLibPath}/jquery/v3.7.1/jquery.min.js`
const mathquillPath = `${thirdPartyLibPath}/mathquill/v0.10.1`
const zwibbler2Path = `${thirdPartyLibPath}/zwibbler/v2`
const katexPath = `${thirdPartyLibPath}/katex/v0.11.1`
const ttsChoicesPath = `${cdnURI}/tts`
const desmosPath = `${thirdPartyLibPath}/desmos/v1.11.0/calculator.js`
const matrixCalculatorPath = `${thirdPartyLibPath}/desmos/v1.11.0/matrix-calculator.js`
const desmosConfigPath = `${cdnURI}/JS/config/desmos-config.json`
const geoGebraPath = `${thirdPartyLibPath}/geogebra/v5.0/deployggb.js`
const sentryWhiteListURLRegex = /edulastic\.com|snapwiz\.net/
const eduScientificCalcPath = `${thirdPartyLibPath}/ev2-scientificcalc`
const eduScientificCalcJsPath = `${eduScientificCalcPath}/CalcSS3.js`
const eduScientificCalcCssPath = `${eduScientificCalcPath}/CalcSS3.css`

const testletMathJax =
  'https://ws-preview.nextera.questarai.com/libs/NexteraMathJax.2.7.5/MathJax.js?config=MML_HTMLorMML-full.js'

const releaseNotesUrl = process.env.REACT_APP_RELEASE_NOTES_PAGE_URL
const nhdoeMaketingAnnouncementUrl =
  process.env.REACT_APP_NHDOE_MARKETING_ANNOUNCEMENT_URL
const dataStudioFeedbackFormUrl =
  process.env.REACT_APP_DATA_STUDIO_FEEDBACK_FORM_URL

const sentryURI =
  process.env.REACT_APP_SENTRY_DSN || process.env.REACT_APP_SENTRY_URI
let segmentURI =
  process.env.REACT_APP_SEGMENT_URI ||
  `${thirdPartyLibPath}/segmentjs/v4.2.2/analytics.js`
if (window.origin.indexOf(pearDeckSLD) > -1) {
  segmentURI = process.env.REACT_APP_PEAR_SEGMENT_URI || segmentURI
}
const segmentVersion = process.env.REACT_APP_SEGMENT_VERSION || '4.2.2'
const isSegmentEnabled = process.env.REACT_APP_ENABLE_SEGMENT === 'true'
const amplitudeApiKey = process.env.REACT_APP_AMPLITUDE_API_KEY || ''
const amplitudeSampleRate = parseFloat(
  process.env.REACT_APP_AMPLITUDE_SAMPLE_RATE || '1.0'
)
const isSessionReplayEnabled =
  process.env.REACT_APP_ENABLE_SESSION_REPLAY === 'true'
const isSessionReplayDebugModeEnabled =
  process.env.REACT_APP_SESSION_REPLAY_DEBUG_MODE === 'true' ||
  process.env.NODE_ENV === 'development'
const isChatWidgetEnabled = process.env.REACT_APP_ENABLE_CHAT_WIDGET === 'true'
const antiScreenshotEnabledDistricts =
  process.env.REACT_APP_ANTI_SCREENSHOT_ENABLED_DISTRICTS || ''
const googleClientSdkUrl = 'https://accounts.google.com/gsi/client'
const googleApiSdkUrl = 'https://apis.google.com/js/api.js'
const googleCalendarApiVersion = 'v3'

const v1RedirectDecryptSalt = process.env.REDIRECT_DECRYPT_SALT || 436792765

export const firebaseConfig = {
  apiKey:
    process.env
      .REACT_APP_FIREBASE_API_KEY /* || "AIzaSyA_2mdY_l-tHgy5LvQigdNmVmqABdx7458" */,
  authDomain:
    process.env
      .REACT_APP_FIREBASE_AUTH_DOMAIN /* || "ev2-dev-88215.firebaseapp.com" */,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID /* || "ev2-dev-88215" */,
}

export const tutorMeSdkConfig = {
  api:
    process.env.REACT_APP_TUTORME_SDK_API ??
    (process.env.NODE_ENV === 'production'
      ? ''
      : 'https://stg-tutor.peardeck.com/api/v1/sdk'),
}

const sentryIgnoreErrors = [
  // Random plugins/extensions
  'top.GLOBALS',
  // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
  'originalCreateNotification',
  'canvas.contentDocument',
  'MyApp_RemoveAllHighlights',
  'http://tt.epicplay.com',
  "Can't find variable: ZiteReader",
  'jigsaw is not defined',
  'ComboSearch is not defined',
  'http://loading.retry.widdit.com/',
  'atomicFindClose',
  // Facebook borked
  'fb_xd_fragment',
  // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
  // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
  'bmi_SafeAddOnload',
  'EBCallBackMessageReceived',
  // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  'conduitPage',
  // edulastic FE specific
  'ResizeObserver loop limit exceeded',
  'invalid password',
  'scrollTop',
  'froala',
  'getBoundingClientRect',
  'Non-Error promise rejection',
  'exceeded',
  'quota',
  'Quota',
  'MouseEvent',
  '/login',
  '403',
  '401',
  'TokenExpire',
  'expired',
  "Cannot read property 'hasClass' of null",
  "Cannot set property 'isFullscreen' of undefined",
  "InvalidStateError: Failed to execute 'transaction' on 'IDBDatabase'",
]
const sentryIgnoreUrls = [
  // Facebook flakiness
  /graph\.facebook\.com/i,
  // Facebook blocked
  /connect\.facebook\.net\/en_US\/all\.js/i,
  // Woopra flakiness
  /eatdifferent\.com\.woopra-ns\.com/i,
  /static\.woopra\.com\/js\/woopra\.js/i,
  // Chrome extensions
  /extensions\//i,
  /^chrome:\/\//i,
  // Other plugins
  /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
  /webappstoolbarba\.texthelp\.com\//i,
  /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
  /\.ru/i,
]

const newsela = {
  clientId:
    process.env
      .REACT_APP_NEWSELA_CLIENT_ID /* || 'Yhp2a64VmxXwRLblLtP64L1WN4JvVRIDG9iVWD3o' */,
  authUrl:
    process.env
      .REACT_APP_NEWSELA_AUTH_URL /* || 'https://edulastic-sso.newsela.com/oauth' */,
  redirectUrl:
    process.env
      .REACT_APP_NEWSELA_REDIRECT_URI /* ||
    'https://edulasticv2-dryrun.snapwiz.net/auth/newsela' */,
  identityUrl:
    process.env
      .REACT_APP_NEWSELA_IDENTITY_URL /* ||
    'https://edulastic-sso.newsela.com/v1/user/me' */,
  loginUrl:
    process.env
      .REACT_APP_NEWSELA_LOGIN_URL /* ||
    'https://edulastic-sso.newsela.com/oauth/authorize' */,
}

// salesforce livechat config
const sfConfig = {
  organizationId: process.env.REACT_APP_SALESFORCE_ORGANIZATION_ID,
  serviceName: process.env.REACT_APP_SALESFORCE_SERVICE_NAME,
  url: process.env.REACT_APP_SALESFORCE_URL,
  scrt2URL: process.env.REACT_APP_SALESFORCE_SCRT2_URL,
}

// Check if chat is in maintenance mode
const isChatMaintenanceMode =
  process.env.REACT_APP_CHAT_MAINTENANCE_MODE === 'true'

const initEmbeddedServiceCloudWidget = (user) => {
  if (!isChatWidgetEnabled) {
    return
  }

  // Show maintenance icon if in maintenance mode
  if (isChatMaintenanceMode) {
    showChatMaintenanceIcon()
    return
  }

  // Enhanced Chat (Embedded Messaging) snippet
  const initEmbeddedMessaging = () => {
    try {
      /* eslint-disable no-undef */
      embeddedservice_bootstrap.settings.language = 'en_US'

      // Pre-populate chat fields with user data
      if (user) {
        // Get current district ID using same logic as backend
        const currentDistrictId =
          user.currentDistrictId ||
          (user.districtIds && user.districtIds.length > 0
            ? user.districtIds[0]
            : '')
        window.addEventListener('onEmbeddedMessagingReady', () => {
          embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({
            site_Url: window.location.origin,
            Org_ID: currentDistrictId,
          })
          embeddedservice_bootstrap.prechatAPI.setVisiblePrechatFields({
            _firstName: {
              value: user.firstName || '',
              isEditableByEndUser: true,
            },
            _lastName: {
              value: user.lastName || '',
              isEditableByEndUser: true,
            },
            _email: {
              value: user.email || '',
              isEditableByEndUser: true,
            },
            Subject: {
              value: 'General Inquiry',
              isEditableByEndUser: true,
            },
            Product: {
              value: 'Edulastic',
              isEditableByEndUser: false,
            },
            School_State: {
              value: '', // not available in user data, this will cause to set default 1st state as 'Alabama'
              isEditableByEndUser: false,
            },
          })
        })
      }

      embeddedservice_bootstrap.init(
        sfConfig.organizationId,
        sfConfig.serviceName,
        sfConfig.url,
        {
          scrt2URL: sfConfig.scrt2URL,
        }
      )
      /* eslint-enable no-undef */
    } catch (err) {
      console.error('Error loading Embedded Messaging: ', err)
    }
  }

  // Load the bootstrap script if not already loaded
  if (!window.embeddedservice_bootstrap) {
    const s = document.createElement('script')
    s.setAttribute('type', 'text/javascript')
    s.setAttribute('src', `${sfConfig.url}/assets/js/bootstrap.min.js`)
    s.onload = () => {
      initEmbeddedMessaging()
    }
    document.body.appendChild(s)
  } else {
    initEmbeddedMessaging()
  }
}

const getSentryReleaseName = () => {
  return `${appVersion}.edu-fe.${appStage}`
}

const kioskChromeAppId = process.env.REACT_APP_KIOSK_CHROME_APP_ID

const isAntiScreenshotEnabled = (districtId = null) => {
  const districtIds = antiScreenshotEnabledDistricts.split(',')
  return districtIds.includes(districtId)
}

const getCDNOrigin = () => {
  try {
    return new URL(cdnURI).origin
  } catch (e) {
    return cdnURI
  }
}

const edYouTubePlayerKey = process.env.REACT_APP_ED_YOUTUBE_PLAYER_KEY

const enableTamperingDetection =
  process.env.REACT_APP_ENABLE_TAMPERING_DETECTION !== 'false'

const videoQuizDefaultCollection = {
  collectionId: process.env.REACT_APP_VIDEO_QUIZ_COLLECTION_ID,
  collectionName: process.env.REACT_APP_VIDEO_QUIZ_COLLECTION_NAME,
  collectionBucketId: process.env.REACT_APP_VIDEO_QUIZ_COLLECTION_BUCKET_ID,
  collectionType: process.env.REACT_APP_VIDEO_QUIZ_COLLECTION_TYPE,
}

const vqLibraryQueryParams = '?source=vq-library'

const nhdoeStateDGId = process.env.REACT_APP_NHDOE_STATE_DISTRICT_GROUP_ID || ''

const SANITIZE_HTML_DEFAULTS = {
  ADD_TAGS: [
    'maction',
    'maligngroup',
    'malignmark',
    'mlongdiv',
    'mscarries',
    'mscarry',
    'msgroup',
    'mstack',
    'msline',
    'msrow',
    'semantics',
    'annotation',
    'annotation-xml',
    'mprescripts',
    'none',
    'textinput',
    'mathinput',
    'mathunit',
    'textdropdown',
    'response',
    'paragraphnumber',
    'mathspan',
    'iframe',
    'annotation',
    'semantics',
  ],
  ADD_ATTS: [
    'responseindex',
    'contenteditable',
    'key',
    'resprops',
    'allow',
    'allowfullscreen',
    'frameborder',
    'scrolling',
    'target',
    'contenteditable',
    'sequence',
  ],
}

const sanitizeHtmlAddTags = [
  ...SANITIZE_HTML_DEFAULTS.ADD_TAGS,
  ...(process.env.REACT_APP_XSS_ADD_TAGS?.split(',').map((tag) => tag.trim()) ||
    []),
]

const sanitizeHtmlAddAtts = [
  ...SANITIZE_HTML_DEFAULTS.ADD_ATTS,
  ...(process.env.REACT_APP_XSS_ADD_ATTRIBUTES?.split(',').map((tag) =>
    tag.trim()
  ) || []),
]

const peardeckDomain =
  process.env.REACT_APP_PEARDECK_DOMAIN || 'https://account.peardeck.com'

const redirectToAllowedRootDomains = [
  'edulastic.com',
  'peardeck.com',
  'snapwiz.net',
  ...(process.env.REACT_APP_PEAR_REDIRECT_TO_ALLOWED_DOMAINS || '')
    .split(',')
    .map((domain) => domain.trim())
    .filter((domain) => !!domain),
]

const getPdfJsDistWorkerUrl = (version) =>
  process.env.REACT_APP_PDF_JS_DIST_WORKER_URL ||
  `${thirdPartyLibPath}/pdfjs-dist/v${version}/pdf.worker.min.mjs`

export default {
  initEmbeddedServiceCloudWidget,
  sentryIgnoreErrors,
  sentryIgnoreUrls,
  appStage,
  getSentryReleaseName,
  appVersion,
  googleClientSdkUrl,
  googleApiSdkUrl,
  googleCalendarApiVersion,
  sentryURI,
  isSegmentEnabled,
  segmentVersion,
  segmentURI,
  cdnURI,
  appEnv,
  sentryWhiteListURLRegex,
  geoGebraPath,
  desmosPath,
  desmosConfigPath,
  matrixCalculatorPath,
  katexPath,
  mathquillPath,
  zwibbler2Path,
  jqueryPath,
  ttsChoicesPath,
  thirdPartyLibPath,
  v1RedirectDecryptSalt,
  eduScientificCalcPath,
  eduScientificCalcJsPath,
  eduScientificCalcCssPath,
  testletMathJax,
  releaseNotesUrl,
  newsela,
  kioskChromeAppId,
  isAntiScreenshotEnabled,
  getCDNOrigin,
  edYouTubePlayerKey,
  pearScriptPath,
  pearScriptDomainIdentifier,
  videoQuizDefaultCollection,
  vqLibraryQueryParams,
  nhdoeStateDGId,
  peardeckDomain,
  sanitizeHtmlAddTags,
  sanitizeHtmlAddAtts,
  redirectToAllowedRootDomains,
  getPdfJsDistWorkerUrl,
  nhdoeMaketingAnnouncementUrl,
  dataStudioFeedbackFormUrl,
  enableTamperingDetection,
  amplitudeApiKey,
  amplitudeSampleRate,
  isSessionReplayEnabled,
  isSessionReplayDebugModeEnabled,
}
